import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component( {
  selector: 'rip-rss-app-ticker',
  template: `
    <div  #containerDiv
         style="max-height: 100%;">
      <rssapp-ticker id="{{rssAppId}}"></rssapp-ticker>
    </div>
  `,

} )

export class RssAppTickerComponent implements AfterViewInit {

  @ViewChild( 'containerDiv', { static: false } ) containerDiv: ElementRef;

  rssAppId: string = environment.common.rssAppId;

  ngAfterViewInit(): void {
    setTimeout( () => {
      const script = document.createElement( 'script' );
      script.src = 'https://widget.rss.app/v1/ticker.js';
      script.async = true;
      this.containerDiv.nativeElement.appendChild( script );
    } );
  }

}
